export default __webpack_public_path__ + "static/media/home-1.fe12062c.png";